const CONTENT_TEXT_DEFAULTS = {
	SITE_NAME: 'SITE_NAME',
	CONTACT_EMAIL: 'CONTACT_EMAIL',
	META_TITLE_SUFFIX: 'META_TITLE_SUFFIX',
	META_DEFAULT_DESCRIPTION: 'META_DEFAULT_DESCRIPTION',
	HOME_META_TITLE: 'HOME_META_TITLE',
	HOME_META_DESCRIPTION: 'HOME_META_DESCRIPTION',
	CITIES_META_TITLE: 'CITIES_META_TITLE',
	CITIES_META_DESCRIPTION: 'CITIES_META_DESCRIPTION',
	COLLECTIONS_META_TITLE: 'COLLECTIONS_META_TITLE',
	COLLECTIONS_META_DESCRIPTION: 'COLLECTIONS_META_DESCRIPTION',
	CITY_META_TITLE: 'CITY_META_TITLE',
	CITY_META_DESCRIPTION: 'CITY_META_DESCRIPTION',
	BLOG_META_TITLE: 'BLOG_META_TITLE',
	BLOG_META_DESCRIPTION: 'BLOG_META_DESCRIPTION',
	ABOUT_META_TITLE: 'ABOUT_META_TITLE',
	ABOUT_META_DESCRIPTION: 'ABOUT_META_DESCRIPTION',
	PRIVACY_META_DESCRIPTION: 'PRIVACY_META_DESCRIPTION',
	PRIVACY_META_TITLE: 'PRIVACY_META_TITLE',
	TERMS_META_DESCRIPTION: 'TERMS_META_DESCRIPTION',
	TERMS_META_TITLE: 'TERMS_META_TITLE',
	DISCLAIMER_META_DESCRIPTION: 'DISCLAIMER_META_DESCRIPTION',
	DISCLAIMER_META_TITLE: 'DISCLAIMER_META_TITLE',
	ABOUT_US_BODY: 'ABOUT_US_BODY',
	PRIVACY_BODY: 'PRIVACY_BODY',
	TERMS_BODY: 'TERMS_BODY',
	DISCLAIMER_BODY: 'DISCLAIMER_BODY',
}

const ROUTE_PREFIX_MAP = {
	'/': 'home',
	'/cities': 'cities',
	'/collections': 'collections',
	'/about-us': 'about-us',
	'/terms-of-service': 'terms-of-service',
	'/privacy-policy': 'privacy-policy',
	'/disclaimer': 'disclaimer',
}

function getContentTextMap(domainConfig) {
	const baseFromDomain = {
		SITE_NAME: domainConfig?.siteName || CONTENT_TEXT_DEFAULTS.SITE_NAME,
		CONTACT_EMAIL: domainConfig?.IAMEMAIL || CONTENT_TEXT_DEFAULTS.CONTACT_EMAIL,
	}
	return {
		...CONTENT_TEXT_DEFAULTS,
		...baseFromDomain,
		...(domainConfig?.contentText || {}),
	}
}

function getRoutePrefix(route = {}) {
	const path = route.path || ''
	if (path.startsWith('/blog/')) {
		return 'blog'
	}
	if (path && path !== '/' && !ROUTE_PREFIX_MAP[path]) {
		return 'city'
	}
	return ROUTE_PREFIX_MAP[path] || 'home'
}

function renderTemplate(template = '', data = {}) {
	const source = String(template || '')
	const resolveValue = (key, fallback) => {
		const candidates = [key, key.toUpperCase(), key.toLowerCase()]
		const matchedKey = candidates.find((item) => data[item])
		return matchedKey ? data[matchedKey] : fallback
	}

	return source
		.replace(/\{\{\s*([A-Z0-9_]+)\s*\}\}/g, (_, key) => resolveValue(key, `{{${key}}}`))
		.replace(/\{\s*([A-Za-z0-9_]+)\s*\}/g, (_, key) => resolveValue(key, `{${key}}`))
}

function getText(contentText = {}, key, fallback = '') {
	const value = contentText[key]
	if (!value || value === key) {
		return fallback
	}
	return value
}

export { CONTENT_TEXT_DEFAULTS, getContentTextMap, getRoutePrefix, renderTemplate, getText }
